import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";
import type { DataViewScope, DataViewVisibility } from "../../../zodios/apiDefinitions/api/dataViews";

type Params = {
  viewType: string;
  datasetKey: string;
  scope?: DataViewScope;
  visibility?: DataViewVisibility;
};

const useDataViewsQueryOptions = ({ viewType, datasetKey, scope, visibility }: Params) => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);

  return queryOptions({
    queryKey: [{ entity: "DataViews", viewType, datasetKey, marketPlace, scope, visibility }],
    queryFn: async () =>
      await apiClient.getDataViews({
        queries: {
          view_type: viewType,
          dataset_key: datasetKey,
          marketplace: marketPlace,
          scope,
          visibility,
        },
      }),
  });
};

export const useDataViews = (params: Params) => useQuery(useDataViewsQueryOptions(params));
